import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router";
import { logOut } from "../store/actions/authActions";

class Dashboard extends React.Component {
  handleLogOut = (e) => {
    e.preventDefault();
    this.props.logOut();
  };

  render() {
    const { auth } = this.props;

    if (auth.uid) {
      return <Navigate to="/teams" />;
    } else {
      return (
        <div class = "text-center">
          <img src = "logo512.png" class="rounded" alt = "logo" width = "200px"/>    
          <div className="text-center">
            <div className="text-primary">
              <h1>Welcome to Educated Brainstorm! </h1>
            </div>
          </div>
          <div className="invisible">
            <div className="text-primary">
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            ------------------------------------------
            </div>
          </div>

          <a class="btn btn-primary" href="/SignUp" role="button">Sign Up</a>


        </div>
          

        
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => dispatch(logOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
